<template>
    <DialogModal :show="modalVisible" @close="close">
        <template #title>
            <div v-if="screen === 'message'">
                Login or Register
            </div>

            <div v-if="screen === 'login'">
                Login
            </div>

            <div v-if="screen === 'register'">
                Register
            </div>
        </template>

        <template #content>
            <div v-if="screen === 'message'">
                {{ message }}
            </div>

            <div v-if="screen === 'login'">
                <form @submit.prevent="login">
                    <div>
                        <Label for="email" value="Email"/>
                        <Input
                            id="email" v-model="loginForm.email" autofocus class="mt-1 block w-full" required
                            type="email"/>
                        <InputError v-if="loginFormErrors.email" :message="loginFormErrors.email[0]" class="mt-1"/>
                    </div>

                    <div class="mt-4">
                        <Label for="password" value="Password"/>
                        <Input
                            id="password" v-model="loginForm.password" autocomplete="current-password"
                            class="mt-1 block w-full"
                            required type="password"/>
                    </div>

                    <div class="block mt-4">
                        <label class="flex items-center">
                            <Checkbox v-model:checked="loginForm.remember" name="remember"/>
                            <span class="ml-2 text-sm text-gray-600">Remember me</span>
                        </label>
                    </div>
                </form>
            </div>

            <div v-if="screen === 'register'">
                <form ref="registerForm" @submit.prevent="register">
                    <div class="mb-4">
                        <Label for="type" value="Account Type*"/>
                        <CardRadioGroup :options="$page.props.userTypes" @update-form="updateRegisterForm"/>
                        <InputError v-if="registerFormErrors.type" :message="registerFormErrors.type[0]" class="mt-1"/>
                    </div>

                    <div class="flex">
                        <div class="grow pr-2">
                            <Label for="first_name" value="First Name*"/>
                            <Input
                                id="first_name"
                                v-model="registerForm.first_name"
                                autocomplete="name"
                                class="mt-1 block w-full"
                                name="first_name"
                                required
                                type="text"
                            />
                            <InputError
                                v-if="registerFormErrors.first_name"
                                :message="registerFormErrors.first_name[0]"
                                class="mt-1"/>
                        </div>

                        <div class="grow pl-2">
                            <Label for="last_name" value="Last Name*"/>
                            <Input
                                id="last_name"
                                v-model="registerForm.last_name"
                                autocomplete="last_name"
                                class="mt-1 block w-full"
                                name="last_name"
                                required
                                type="text"
                            />
                            <InputError
                                v-if="registerFormErrors.last_name"
                                :message="registerFormErrors.last_name[0]"
                                class="mt-1"/>
                        </div>
                    </div>

                    <div class="mt-4">
                        <Label for="email" value="Email*"/>
                        <Input
                            id="email"
                            v-model="registerForm.email"
                            class="mt-1 block w-full"
                            name="email"
                            required
                            type="email"
                        />
                        <InputError
                            v-if="registerFormErrors.email"
                            :message="registerFormErrors.email[0]"
                            class="mt-1"/>
                    </div>

                    <div class="flex">
                        <div class="mt-4 grow pr-2">
                            <Label for="password" value="Password*"/>
                            <Input
                                id="password"
                                v-model="registerForm.password"
                                autocomplete="new-password"
                                class="mt-1 block w-full"
                                name="password"
                                required
                                type="password"
                            />
                            <InputError
                                v-if="registerFormErrors.password"
                                :message="registerFormErrors.password[0]"
                                class="mt-1"/>
                        </div>

                        <div class="mt-4 grow pl-2">
                            <Label
                                for="password_confirmation"
                                value="Confirm Password*"
                            />
                            <Input
                                id="password_confirmation"
                                v-model="registerForm.password_confirmation"
                                autocomplete="new-password"
                                class="mt-1 block w-full"
                                name="password_confirmation"
                                required
                                type="password"
                            />
                            <InputError
                                v-if="registerFormErrors.password_confirmation"
                                :message="registerFormErrors.password_confirmation[0]"
                                class="mt-1"/>
                        </div>
                    </div>

                    <div
                        class="mt-6"
                    >
                        <Label for="terms">
                            <div class="flex items-center">
                                <Checkbox
                                    id="terms"
                                    v-model:checked="registerForm.terms"
                                    name="terms"
                                />

                                <div class="ml-2">
                                    I agree to the
                                    <a
                                        :href="route('terms.show')"
                                        class="button-link"
                                        target="_blank"
                                    >Terms of Use</a
                                    >
                                    and
                                    <a
                                        :href="route('policy.show')"
                                        class="button-link"
                                        target="_blank"
                                    >Privacy Policy</a
                                    >*
                                </div>
                            </div>

                        </Label>

                        <InputError
                            v-if="registerFormErrors.terms"
                            :message="registerFormErrors.terms[0]"
                            class="mt-1"/>
                    </div>
                </form>
            </div>
        </template>
        <template #footer>

            <div v-if="screen === 'message'" class="flex w-full justify-between">
                <div>
                    <button
                        class="button-default"
                        @click.prevent="close"
                    >
                        Cancel
                    </button>
                </div>
                <div>
                    <button class="button-default" @click.prevent="changeScreen('login')"
                    >
                        Login
                    </button>
                    <button class="button-primary ml-3" @click.prevent="changeScreen('register')"
                    >
                        Register
                    </button>
                </div>
            </div>

            <div v-if="screen === 'login'" class="flex w-full justify-between">
                <div>
                    <button
                        class="button-default"
                        @click.prevent="changeScreen('message')"
                    >
                        Back
                    </button>
                </div>
                <div>
                    <button
                        :class="{ 'opacity-25': loginFormLoading }" :disabled="loginFormLoading"
                        class="ml-4 button-primary" @click.prevent="login"
                    >
                        Login
                    </button>
                </div>

            </div>

            <div v-if="screen === 'register'" class="flex w-full justify-between">
                <div>
                    <button
                        class="button-default"
                        @click.prevent="changeScreen('message')"
                    >
                        Back
                    </button>
                </div>
                <div>
                    <button :disabled="registerFormLoading" class="button-primary" @click.prevent="register">
                        Register
                    </button>
                </div>
            </div>


        </template>
    </DialogModal>
</template>
<script>
import DialogModal from '@/Components/Legacy/Jetstream/DialogModal.vue';
import Input from '@/Components/Legacy/Jetstream/Input.vue';
import Checkbox from '@/Components/Legacy/Jetstream/Checkbox.vue';
import Label from '@/Components/Legacy/Jetstream/Label.vue';
import axios from 'axios';
import InputError from '@/Components/Legacy/Jetstream/InputError.vue';
import {router} from '@inertiajs/vue3';
import CardRadioGroup from '@/Components/Legacy/CardRadioGroup.vue';

export default {
    components: {
        InputError,
        CardRadioGroup,
        DialogModal,
        Input,
        Checkbox,
        Label,
    },
    props: {
        modalVisible: {
            type: Boolean,
            default: false
        },

        message: {
            type: String,
            required: false,
            default: () => 'Please login or register to continue'
        }
    },
    emits: ['toggleModal', 'success'],
    data() {
        return {
            screen: 'message',
            loginForm: this.$inertia.form({
                email: '',
                password: '',
                remember: false
            }),
            loginFormErrors: {},
            loginFormLoading: false,
            registerFormLoading: false,
            registerFormErrors: {},
            registerForm: this.$inertia.form({
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                password_confirmation: '',
                terms: false,
                type: '',
            }),
        };
    },

    methods: {
        async success() {
            router.reload({
                only: ['user'], onSuccess: () => {
                    this.$emit('success', true);
                }
            });
        },
        close() {
            this.$emit('toggleModal', false);
        },
        changeScreen(screen) {
            this.screen = screen;
        },

        login() {
            this.loginFormLoading = true;
            this.loginFormErrors = {};

            const data = this.loginForm
                .transform(data => ({
                    ...data,
                    remember: this.loginForm.remember ? 'on' : ''
                })).data();

            axios.post(this.route('login'), data).then(() => {
                this.loginFormLoading = false;
                this.success();

            }).catch((error) => {
                this.loginFormErrors = error.response.data.errors;
                this.loginFormLoading = false;
            });
        },


        updateRegisterForm(object) {
            this.registerForm[object.field] = object.value;
        },

        register() {
            if (!this.$refs.registerForm.checkValidity()) {
                // Try focus on the error
                this.$refs.registerForm.reportValidity();
                return;
            }

            this.registerFormLoading = true;

            const data = this.registerForm.data();


            axios.post(this.route('register'), data).then(() => {
                this.registerFormLoading = false;
                this.success();

            }).catch((error) => {
                this.registerFormErrors = error.response.data.errors;
                this.registerFormLoading = false;
            });
        },
    }
};
</script>
